import type { FaireProductEntity } from "../../entity_types/product";

export const p_7d2krzpz6j: FaireProductEntity = {
  token: "p_7d2krzpz6j",
  type: "product",
  name: "Free Range Chicken Water Bottle Sticker, Laptop Decal",
  brandName: "liadelyonart",
  imageUrl:
    "https://cdn.faire.com/fastly/764d14de94e09bf5542db970103c33f38d9e306bcd7dc1cc711eec5b4d6d0c69.png",
  priceDollars: 1.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/11fbfa748692fb4666d9b790c92e5cde616508c19d1428bc5a8dadd18dfc875f.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
